// Capability vocabulary — the site features the agent can compose. The wizard
// surfaces these as checkboxes; the runner uses them to drive section
// composition and which capability pages to include.
export const CAPABILITIES = [
    { id: "storefront", label: "Sell things online", note: "Products, checkout, cart" },
    { id: "booking", label: "Take appointments", note: "Calendar, slots, confirmations" },
    { id: "menu", label: "Show a menu", note: "Categories, items, prices" },
    { id: "events", label: "List events", note: "Recurring or one-off" },
    { id: "gallery", label: "Show a photo gallery", note: "Work, food, space" },
    { id: "newsletter", label: "Collect emails", note: "Subscribers, updates" },
    { id: "blog", label: "Write posts / news", note: "Updates, journal" },
    { id: "contact", label: "Be easy to reach", note: "Form, hours, address (always on)", alwaysOn: true },
];
export function getCapability(id) {
    return CAPABILITIES.find((c) => c.id === id);
}
